/**
 * A folha do PDF: A4 fixo e margem zero. O respiro de cada folha vem do conteúdo (recuo repetido a
 * cada quebra) e o rodapé é um elemento fixo, que o Chrome repete em toda folha — assim o PDF sai
 * igual com qualquer "Margens" escolhido na impressão. Com as margens do @page, "Nenhuma" (que o
 * Chrome lembra das etiquetas) apagava o rodapé e colava o texto no topo.
 */
export function cssDaPagina(fundoDaFolha: string | null): string {
  return [
    `@page { size: A4; margin: 0;${fundoDaFolha ? ` background: ${fundoDaFolha};` : ""} }`,
    // Fundo colorido na folha inteira: o da página do app e o do contêiner da tela não podem
    // cobrir com o branco deles.
    fundoDaFolha ? " @media print { html, body, [data-catalogo-impresso] { background: transparent !important; } }" : "",
  ].join("");
}
